import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Styles } from "./styles/pagination.js";

class Pagination extends Component {
    render() {
        const { currentPage, totalPages, onPageChange } = this.props;
        const pages = [];

        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }

        return (
            <Styles>
                {/* Pagination */}
                <ul className="pagination-box list-unstyled list-inline">
                    <li className={`list-inline-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <Link to="#" onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}>
                            <i className="las la-angle-double-left"></i>
                        </Link>
                    </li>
                    {pages.map(page => (
                        <li key={page} className={`list-inline-item ${currentPage === page ? 'active' : ''}`}>
                            <Link to="#" onClick={() => onPageChange(page)}>
                                {page}
                            </Link>
                        </li>
                    ))}
                    <li className={`list-inline-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <Link to="#" onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}>
                            <i className="las la-angle-double-right"></i>
                        </Link>
                    </li>
                </ul>
            </Styles>
        )
    }
}

export default Pagination
